import { h } from "@stencil/core";

// the props in this are (factory) functions instead of attributes because it's not recommended to reuse JSX elements in Stencil
// see https://stenciljs.com/docs/templating-jsx#avoid-shared-jsx-nodes
export const stageSvgs = {
  pause: () => (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.75051 18.0018H7.50049C7.05049 18.0018 6.75049 17.7018 6.75049 17.2518V6.75137C6.75049 6.30136 7.05049 6.00134 7.50049 6.00134H9.75051C10.2005 6.00134 10.5005 6.30136 10.5005 6.75137V17.2518C10.5005 17.7018 10.2005 18.0018 9.75051 18.0018ZM17.2506 17.2518V6.75137C17.2506 6.30136 16.9506 6.00134 16.5006 6.00134H14.2506C13.8005 6.00134 13.5005 6.30136 13.5005 6.75137V17.2518C13.5005 17.7018 13.8005 18.0018 14.2506 18.0018H16.5006C16.9506 18.0018 17.2506 17.7018 17.2506 17.2518Z"
      />
    </svg>
  ),
  play: () => (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2377 10.7334C17.9127 11.1084 18.212 11.9327 17.8377 12.6819C17.6877 12.9819 17.4627 13.2069 17.2377 13.2819L8.39749 18.1509C7.64899 18.6009 6.67474 18.3759 6.22549 17.6267C6.07549 17.4017 6.00049 17.1767 6.00049 16.8774V7.13719C6.07249 6.27694 6.76099 5.62219 7.60699 5.63269L7.72324 5.63869C7.94824 5.63869 8.24824 5.71369 8.47324 5.86369L17.237 10.7327L17.2377 10.7334Z"
      />
    </svg>
  )
};
